module.exports = __webpack_public_path__ + "img/xxcyu_f1cbd9376.png";